module.exports = __webpack_public_path__ + "img/ovulos o tabletas vaginales.65f583fb.png";